import { withOptimizely } from '@optimizely/react-sdk';

import { UniversalMenuItem } from '.';

import type { ReactSDKClient, WithOptimizelyProps } from '@optimizely/react-sdk';
import type { IUniversalMenuItem } from './types';


const clickHandler = ({ action, optimizely, text }: { action?: () => void; optimizely: ReactSDKClient | null; text?: string; parentLabel?: string; }) => {
  if (
    optimizely
    && (text === 'Sign up' || text === 'Get a demo')
  ) {
    return () => {
      let metric = 'global_cta_click_signup';

      if (text === 'Get a demo') {
        metric = 'global_cta_click_demo';
      }

      optimizely.track(metric);

      if (action) {
        action();
      }
    };
  }

  return action;
};

export const UniversalMenuItemWithOptimizelyProps = <T extends React.ElementType = 'a'>({
  children,
  label,
  onClick,
  optimizely,
  optimizelyReadyTimeout,
  isServerSide,
  ...props
}: IUniversalMenuItem<T> & Omit<React.ComponentPropsWithoutRef<T>, keyof IUniversalMenuItem<T>> & WithOptimizelyProps) => {

  return (
    <UniversalMenuItem
      children={children}
      onClick={clickHandler({ action: onClick, optimizely, text: label })}
      label={label}
      {...props as any}
    />
  );
};

export const UniversalMenuItemWithOptimizely = withOptimizely(UniversalMenuItemWithOptimizelyProps);
